/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';
import { dataManagerEntryPoint } from '@atlassian/jira-servicedesk-insight-data-manager/src/ui/entrypoint.tsx';
import { appUsageEntryPoint } from '@atlassian/jira-servicedesk-insight-global-configuration/src/ui/app-usage/entrypoint.tsx';
import { announcementBannerEntryPoint } from '@atlassian/jira-servicedesk-insight-global-configuration/src/ui/announcement-banner/entrypoint.tsx';
import { themeSettingsEntryPoint } from '@atlassian/jira-servicedesk-insight-global-configuration/src/ui/theme-settings/entrypoint.tsx';
import { iconsPageEntryPoint } from '@atlassian/jira-servicedesk-insight-global-configuration/src/ui/icons-tab/entrypoint.tsx';
import { statusesPageEntryPoint } from '@atlassian/jira-servicedesk-insight-global-configuration/src/ui/statuses-tab/entrypoint.tsx';
import { commonDataModelEntryPoint } from '@atlassian/jira-servicedesk-insight-global-configuration/src/ui/common-data-model-tab/entrypoint.tsx';
import { referenceTypesPageEntryPoint } from '@atlassian/jira-servicedesk-insight-global-configuration/src/ui/reference-types-tab/entrypoint.tsx';

export const assetsGlobalSettingsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-assets-global-settings-entrypoint" */ './index.tsx'),
	),
	getPreloadProps: ({ context: { query } }: EntryPointRouteParams) => {
		if (!fg('aurum_assets_new_settings_page')) {
			return {};
		}

		const { menu } = query;
		const defaultMenu = fg('aurum-677-assets-usage-migration')
			? 'app-usage'
			: 'global-reference-types';
		const targetMenu = menu ?? defaultMenu;

		if (targetMenu === 'data-manager') {
			return {
				entryPoints: {
					dataManagerEntryPoint: {
						entryPoint: dataManagerEntryPoint,
						entryPointParams: {},
					},
				},
			};
		}

		if (targetMenu === 'app-usage') {
			return {
				entryPoints: {
					appUsageEntryPoint: {
						entryPoint: appUsageEntryPoint,
						entryPointParams: {},
					},
				},
			};
		}

		if (targetMenu === 'announcement-banner') {
			return {
				entryPoints: {
					announcementBannerEntryPoint: {
						entryPoint: announcementBannerEntryPoint,
						entryPointParams: {},
					},
				},
			};
		}

		if (targetMenu === 'theme') {
			return {
				entryPoints: {
					themeSettingsEntryPoint: {
						entryPoint: themeSettingsEntryPoint,
						entryPointParams: {},
					},
				},
			};
		}

		if (targetMenu === 'global-icons') {
			return {
				entryPoints: {
					iconsPageEntryPoint: {
						entryPoint: iconsPageEntryPoint,
						entryPointParams: {},
					},
				},
			};
		}

		if (targetMenu === 'global-statuses') {
			return {
				entryPoints: {
					statusesPageEntryPoint: {
						entryPoint: statusesPageEntryPoint,
						entryPointParams: {},
					},
				},
			};
		}

		if (targetMenu === 'commonDataModel') {
			return {
				entryPoints: {
					commonDataModelEntryPoint: {
						entryPoint: commonDataModelEntryPoint,
						entryPointParams: {},
					},
				},
			};
		}

		if (targetMenu === 'global-reference-types') {
			return {
				entryPoints: {
					referenceTypesPageEntryPoint: {
						entryPoint: referenceTypesPageEntryPoint,
						entryPointParams: {},
					},
				},
			};
		}
		return {};
	},
});
